import React, { useState, useRef, useEffect } from "react";
import "./Chatbot.css";
import { IoSend, IoClose, IoSparkles } from "react-icons/io5";
import { HiVolumeUp } from "react-icons/hi";
import { ttsService } from "../services/ttsService";

function Chatbot({ onClose }) {
  const [messages, setMessages] = useState([
    {
      sender: "bot",
      text: "Hi! I'm Prasanna's AI assistant. Ask me anything about his backend experience, system architecture, or tech stack.",
    },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [speakReplies, setSpeakReplies] = useState(false);
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, loading]);

  const handleSend = async (e) => {
    e.preventDefault();
    const query = input.trim();
    if (!query || loading) return;

    if (query.length > 280) {
      alert("Please limit your question to 280 characters.");
      return;
    }

    const newMessages = [...messages, { sender: "user", text: query }];
    setMessages(newMessages);
    setInput("");
    setLoading(true);

    try {
      const response = await fetch("/api/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: query }),
      });

      const data = await response.json();
      const botReply =
        data.reply ||
        data.error ||
        "I can answer questions regarding Prasanna Kumar's engineering background.";

      setMessages([...newMessages, { sender: "bot", text: botReply }]);

      if (speakReplies && data.reply) {
        ttsService.speak(data.reply);
      }
    } catch (err) {
      setMessages([
        ...newMessages,
        {
          sender: "bot",
          text: "Could not reach the assistant endpoint. Please ensure the Netlify Function is deployed.",
        },
      ]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="chat-modal-overlay">
      <div className="chat-window">
        {/* Header */}
        <div className="chat-header">
          <div className="chat-header-title">
            <IoSparkles className="chat-icon-sparkle" />
            <div>
              <h3>Ask Prasanna's Avatar</h3>
              <span className="chat-status-sub">Grounded in verified experience</span>
            </div>
          </div>

          <div className="chat-header-actions">
            <button
              className={`chat-audio-toggle ${speakReplies ? "active" : ""}`}
              onClick={() => setSpeakReplies(!speakReplies)}
              title={speakReplies ? "Mute automatic spoken replies" : "Enable spoken replies"}
              aria-label="Toggle voice output for replies"
            >
              <HiVolumeUp size={18} />
            </button>
            <button className="chat-close-btn" onClick={onClose} aria-label="Close chat">
              <IoClose size={22} />
            </button>
          </div>
        </div>

        {/* Message Stream */}
        <div className="chat-messages">
          {messages.map((msg, index) => (
            <div key={index} className={`chat-bubble-row ${msg.sender}`}>
              <div className={`chat-bubble ${msg.sender}`}>
                <p>{msg.text}</p>
              </div>
            </div>
          ))}

          {loading && (
            <div className="chat-bubble-row bot">
              <div className="chat-bubble bot loading-bubble">
                <span className="typing-dot"></span>
                <span className="typing-dot"></span>
                <span className="typing-dot"></span>
              </div>
            </div>
          )}
          <div ref={messagesEndRef} />
        </div>

        {/* Form Input */}
        <form className="chat-input-area" onSubmit={handleSend}>
          <div className="input-wrapper">
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Ask about microservices, Go, Cassandra..."
              maxLength={280}
              disabled={loading}
              autoFocus
            />
            <span className="char-counter">{input.length}/280</span>
          </div>

          <button
            type="submit"
            className="chat-send-btn"
            disabled={!input.trim() || loading}
            aria-label="Send message"
          >
            <IoSend size={18} />
          </button>
        </form>
      </div>
    </div>
  );
}

export default Chatbot;
